import debounce from 'lodash.debounce';
import { store } from 'reactApp/store';

import { setMedia } from './media.actions';
import { MediaTypes } from './media.types';

let isInitiated = false;

const mediumDesktop = '(min-width: 1360px)';
const smallDesktop = '(min-width: 1024px)';
const tablet = '(min-width: 768px)';
const smallPhone = '(max-width: 375px)';

export const isMatch = (media: string): boolean => window.matchMedia(media).matches;

const match = debounce((): void => {
    const windowWidth = window.innerWidth;
    if (isMatch(mediumDesktop)) {
        store.dispatch(setMedia({ type: MediaTypes.DESKTOP_MEDIUM, windowWidth }));
    } else if (isMatch(smallDesktop)) {
        store.dispatch(setMedia({ type: MediaTypes.DESKTOP_SMALL, windowWidth }));
    } else if (isMatch(tablet)) {
        store.dispatch(setMedia({ type: MediaTypes.TABLET, windowWidth }));
    } else if (isMatch(smallPhone)) {
        store.dispatch(setMedia({ type: MediaTypes.PHONE_SMALL, windowWidth }));
    } else {
        store.dispatch(setMedia({ type: MediaTypes.PHONE, windowWidth }));
    }
}, 200);

export const initMedia = (): void => {
    if (!isInitiated) {
        isInitiated = true;
        match();
        window.addEventListener('resize', match);
    }
};

export { match as mediaMatch };
